export type VerificationBusinessTypeValue =
  | "SOLE_PROPRIETOR"
  | "LLP_LLC_PARTNERSHIP"
  | "PRIVATE_LIMITED"
  | "NONPROFIT_GOVT"
  | "OTHER";

/** Which verification PDF the selected business structure requires. */
export function getVerificationDocKind(
  value: string | null | undefined
): "affidavit" | "authority" | null {
  if (!value) return null;
  if (value === "SOLE_PROPRIETOR" || value === "LLP_LLC_PARTNERSHIP") return "affidavit";
  if (value === "PRIVATE_LIMITED" || value === "NONPROFIT_GOVT" || value === "OTHER") return "authority";
  return null;
}

export const VERIFICATION_BUSINESS_TYPE_SELECT_DATA: { value: string; label: string }[] = [
  { value: "SOLE_PROPRIETOR", label: "Sole Proprietor" },
  { value: "LLP_LLC_PARTNERSHIP", label: "LLP / LLC / Partnership" },
  { value: "PRIVATE_LIMITED", label: "Private Limited / Ltd / Corporation" },
  { value: "NONPROFIT_GOVT", label: "Non-Profit / Government" },
  { value: "OTHER", label: "Other" },
];
